export default {
  namespaced: true,
  state: {
    filterName: ''
  },
  getters: {
    getFilterName (state) {
      return state.filterName
    }
  },
  mutations: {
    setFilterName (state, filterName) {
      state.filterName = filterName
    }
  }
}
